
import React from 'react';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="w-full text-center p-4 mt-8 bg-primary-bg text-text-white text-sm font-montserrat">
      <p>&copy; {currentYear} All rights reserved.</p>
      <p className="mt-2">
        Powered by{' '}
        <a 
          href="https://planyvo.com" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-accent-gold hover:text-soft-gold underline transition duration-300"
          aria-label="Visit Planyvo.com"
        >
          Planyvo.com
        </a>
      </p>
    </footer>
  );
};